<template>
  <div class="box">
    <div class="box-header">
      <h3 class="box-title">Gallery</h3>
      <p>W:1280 x H:720</p>
    </div>
    <div class="control grids is-4-desktop gap-20-desktop">
      <label class="file-placeholder" v-for="(i, index) in gelleryFIle" :key="index">
        <!-- if have image -->
        <img :src="$urlImageShow + i" alt="" />
        <i class="fa-solid fa-trash" @click="gelleryFIle.splice(index, 1)"></i>
      </label>
      <div class="add" @click="uploadFileGellery()"><i class="fa-light fa-plus"></i></div>
      <input hidden="hidden" name="image" v-model="gelleryFIle" type="text" />
      <input hidden="hidden" id="file" name="image" ref="fileinputGellery" type="file" @input="onSelectFileGellery" />
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ['isGellery'],
  data: () => ({
    imageDataGellery: null,
    gelleryFIle: []
  }),
  watch: {
    gelleryFIle: {
      handler(val) {
        this.$emit("input", val)
      },
      immediate: true,
      deep: true
    },
    isGellery(){
      this.gelleryFIle=this.isGellery
    }
  },
  methods: {
    uploadFileGellery() {
      this.$refs.fileinputGellery.click();
    },
    async onSelectFileGellery() {
      const input = this.$refs.fileinputGellery;
      const files = input.files;

      const file = files[0];
      // console.log(size, "MB")

      const formData = new FormData();

      formData.append("file", file);
      // console.log(formData)
      if (file) {
        const filesize = file.size / 1024;
        // console.log(filesize, "KB")
        const size = 5 * 1024;
        if (filesize < size) {
          this.errorfileSize = file.name;
          axios.defaults.headers.common[
            "Authorization"
          ] = this.$store.getters.Token;
          const res = await axios.post(`${this.$urlImage}`, formData);
          this.imageDataGellery = `${this.$urlImageShow}` + res.data.fileKey;
          if (res.data.message) {
            this.errorfileSize = "The file must be .JPG, .PNG. JPEG, .SVG";
            this.gelleryFIle = null;
            this.imageDataGellery = null;
          }
          if (res.data.fileKey) {
            this.errorfileSize = file.name;

            this.gelleryFIle.push(res.data.fileKey);

            if (files && files[0]) {
              const reader = new FileReader();
              reader.onload = (e) => {
                this.imageDataGellery = [e.target.result];
              };
              reader.readAsDataURL(files[0]);
              this.$emit("input is-focused", files[0]);
            }
          }
          // console.log(res.data.file.size)
        } else {
          this.errorfileSize = "The file Size is too much";
          this.imageDataGellery = null;
        }
      }
    },
  }
};
</script>

<style lang="scss" scoped>
input {
  display: none;
}

.file-placeholder {
  content: "";
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border: 1px solid var(--border-color);
  background-color: var(--light-grey-color);
  cursor: pointer;
  aspect-ratio: 16/10;
  position: relative;

  i {
    cursor: pointer;
    top: 0;
    right: 0;
    position: absolute;
    width: 30px;
    height: 30px;
    border-radius: 0 0 0 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--alert-color);
    color: #fff;
  }

  img {
    aspect-ratio: 16/10;
    object-fit: cover;
    display: block;
  }
}

.add {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  cursor: pointer;
  background-color: rgba(var(--primary-color-rgb), 0.05);
  border: 1px solid var(--primary-color);

  i {
    color: var(--primary-color);
    font-size: var(--xxlg-font);
  }
}
</style>
